const EXPECTED_MEDIA_ERROR_NAMES = new Set([
  'AbortError',
  'NotAllowedError',
  'NotSupportedError',
])

export function isExpectedMediaPlayError(error) {
  return Boolean(error && EXPECTED_MEDIA_ERROR_NAMES.has(error.name))
}

export async function playMediaSafely(media) {
  if (!media || typeof media.play !== 'function') return false

  try {
    const result = media.play()
    if (result && typeof result.then === 'function') {
      await result
    }
    return true
  } catch (error) {
    if (isExpectedMediaPlayError(error)) return false
    throw error
  }
}
